<template>
  <div class="content-main">
    <section id="uso-cientifico">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-index">
            <h2>Uso científico</h2>
          </div>
          <p>
            Considerando o crescente interesse de estudantes, professores de 
            graduação e pós-graduação, bem como de profissionais especialistas 
            que elaboram relatórios técnicos em utilizar o <strong>eSUS Feedback</strong> como 
            metodologia ou citar seus dados em estudos técnicos e trabalhos 
            científicos voltados ao Monitoramento e Avaliação na Atenção 
            Primária à Saúde (M & A na APS) e áreas correlatas, estamos 
            disponibilizando esta compilação de produções acadêmicas relacionadas.
          </p>
          <p>
            Cada produção científica listada está identificada com seu tipo,
            título, autor principal e ano de publicação, facilitando o acesso e
            consolidando ainda mais o <strong>eSUS Feedback</strong> no que diz
            respeito a confiabilidade dos dados apresentados e disponibilizados,
            tanto na área restrita como na área pública.

            Cada produção científica apresentada está devidamente identificada por tipo, 
            título, autor principal, local da publicação e ano, visando facilitar o acesso, 
            fortalecer a utilização e consolidar ainda mais a credibilidade do <strong>eSUS Feedback</strong> 
            quanto à confiabilidade das informações apresentadas e disponibilizadas, tanto 
            na área restrita quanto na área pública.
          </p>
          <Tabela
            ref="table"
            :cadastros="displayedCadastros"
            :loading="table.loading"
            @filterSearch="filterSearch($event)"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Tabela from './Tabela.vue'
import { dadosUsoCientifico } from './arquivos.js'

export default {
  name: 'UsoCientifico',
  components: {
    Tabela,
  },
  mounted() {
    // Ordena pelo id em ordem decrescente
    const dadosOrdenados = dadosUsoCientifico.sort((a, b) => {
      // Tratando (ex: '10-1')
      const idA = String(a.id).replace('-', '.');
      const idB = String(b.id).replace('-', '.');
      
      //  decrescente
      return parseFloat(idB) - parseFloat(idA) || idB.localeCompare(idA);
    });
    this.table.items = dadosOrdenados;
  },
  data() {
    return {
      filterSearchTable: false,
      table: {
        items: [],
        loading: false,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.table.items
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
  },
}
</script>

<style>
#uso-cientifico {
  margin-top: 0px;
}
</style>
